package org.hs_soft.runmynesto.domain.usecase.options.export

import org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info.CashRegisterGlobalModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.UpdateCashReigsterGloabalRepository

class UpdateCashRegisterGlobalUseCase(
    private val updateCashRegisterGlobalRepository: UpdateCashReigsterGloabalRepository
) {
    suspend operator fun invoke(title: String, value: Any): CashRegisterGlobalModel {
        return updateCashRegisterGlobalRepository.updateCashRegisterGlobal(title, value)
    }
} 